import types from '../mutation-types';
import AttachmentsAPI from '../../api/attachments';

export const state = {
  records: [],
  contactRecords: {},
  meta: {
    totalCount: 0,
    currentPage: 1,
  },
  filters: {
    contactId: null,
    fileType: null,
    since: null,
    until: null,
    page: 1,
  },
  uiFlags: {
    isFetching: false,
    isFetchingContact: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAttachments(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getFilters(_state) {
    return _state.filters;
  },
  getContactAttachments: _state => contactId => {
    return _state.contactRecords[contactId] || [];
  },
};

export const actions = {
  getAttachments: async ({ commit }, filters = {}) => {
    commit(types.SET_MEDIA_LIBRARY_UI_FLAG, { isFetching: true });
    commit(types.SET_MEDIA_LIBRARY_FILTERS, filters);
    try {
      const response = await AttachmentsAPI.get(filters);
      commit(types.SET_MEDIA_LIBRARY_ATTACHMENTS, response.data.payload);
      commit(types.SET_MEDIA_LIBRARY_META, {
        totalCount: response.data.meta?.total_count || 0,
        currentPage: response.data.meta?.current_page || filters.page || 1,
      });
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MEDIA_LIBRARY_UI_FLAG, { isFetching: false });
    }
  },
  getContactAttachments: async ({ commit }, { contactId, page = 1 }) => {
    commit(types.SET_MEDIA_LIBRARY_UI_FLAG, { isFetchingContact: true });
    try {
      const response = await AttachmentsAPI.getByContact(contactId, page);
      commit(types.SET_CONTACT_MEDIA_ATTACHMENTS, {
        contactId,
        attachments: response.data.payload,
      });
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MEDIA_LIBRARY_UI_FLAG, { isFetchingContact: false });
    }
  },
};

export const mutations = {
  [types.SET_MEDIA_LIBRARY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_MEDIA_LIBRARY_ATTACHMENTS](_state, data) {
    _state.records = data;
  },
  [types.SET_MEDIA_LIBRARY_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.SET_MEDIA_LIBRARY_FILTERS](_state, data) {
    _state.filters = {
      ..._state.filters,
      ...data,
    };
  },
  [types.SET_CONTACT_MEDIA_ATTACHMENTS](_state, { contactId, attachments }) {
    _state.contactRecords = {
      ..._state.contactRecords,
      [contactId]: attachments,
    };
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
